require('jquery-ui/accordion'); // app/views/customer_service_notes/_note_stream.html.haml
require('jquery-ui/core'); // Dependency from accordion and others
require('jquery-ui/datepicker'); // All over the place
require('jquery-ui/tooltip'); // All over the place
require('jquery-ui/widget'); // Dependency from accordion and others
